import React,{useState,useEffect,useRef} from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Label,
    FormGroup,
    Input,
    Table,
    Row,
    Col,
    Modal,
    ModalBody,
    CustomInput,
  } from "reactstrap";
  import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
  import ReactBSAlert from "react-bootstrap-sweetalert";
  import {PENDING_CHANNELS,CHANNEL_TEMPLATES_APPROVE,APPROVED_CHANNELS} from "../../constants"
import axios from "axios";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from "react-responsive-pagination";

const ApprovedSMSChannels=()=>{
    const [alert, setAlert] = useState(null);
    const [templates, setTemplates] = useState([]);
    const notificationAlertRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);

    useEffect(()=>{
      getPendingChannels(1);
    },[])

    const getPendingChannels=(pageNo)=>{
    
      setCurrentPage(pageNo);
      let payload = {
        page:pageNo,
        client_id:user?.client
        
         //0->Pending,1->Approve, 2-> Reject
      }
      axios.get(PENDING_CHANNELS+ "?page=" + pageNo+"&status=1"+"&channel=sms&client_id="+user?.client).then(res=>{setTemplates(res?.data)
        setIsLoading(false)
      }).catch((err)=>{
        let options={}
         options = {
          place: "tr",
          message: "Unable to fetch records",
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef?.current.notificationAlert(options);
        console.log(err)})
    }
   
    return (
      <>
        <div className="content pd-0 ">
        {alert}
          <Row className="Roles listing">
            <Card>
              <CardBody >
                <h3> Approved Templates</h3>
              <LoadingScreen
                children=""
                loading={isLoading}
                bgColor="rgba(0,0,0,0.7)"
                spinnerColor="#9ee5f8"
                textColor="#676767"
                logoSrc={logo}
                text="Loading..."
              ></LoadingScreen>
              <NotificationAlert ref={notificationAlertRef} />
                
                  <Row>
                  <TableContainer component={Paper} className="tableheight">
                    <Table responsive striped >
                      <thead>
                        <tr>
                          <th>Sno</th>
                          <th>Channel</th>
                          <th>Template Id</th>
                          <th>Sender Id</th>
                          <th>Content</th>
                          <th>Status</th>

                        </tr>
                      </thead>
                      <tbody>
                        
                        {
                        templates?.data?.length>0?templates?.data?.map((item,index)=>{
                          
                            return(
                              <tr>
                                 <td > {++index}</td>
                                 <td > {item.channels_type}</td>
                                 <td > {item.template}</td>
                                 <td > {item.senderid}</td>
                                 <td > {item.content}</td>
                                 <td > {item.is_approved==1?"Approved":"Pending"}</td>

                               
                              </tr>
                            )
                          }):<tr>
                            <td colSpan={6}>No Records Found</td>
                          </tr>

                        }
                        {/* <tr>
                            <td >TDR </td>
                            <td>Temp345</td>
                            <td>Temp</td>
                            <td>765432</td>
                          <td>
                            <Badge
                              className="badge badge-warning"
                              color="success"
                              onClick={()=>confirmdeleteUser(2)}
                              style={{cursor:"pointer"}}
                            >
                              Pending
                            </Badge>
                          </td>
                        </tr> */}
                      </tbody>
                    </Table>
                    </TableContainer>
                  </Row>
                
              </CardBody>
              {templates?.num_of_pages > 0 && (
              <div style={{ marginLeft: "auto", padding: "8px" }}>
                <ResponsivePagination
                  current={currentPage}
                  total={templates?.num_of_pages}
                  onPageChange={(newPage) => {
                    getPendingChannels(newPage);
                  }}
                />
              </div>
            )}
            </Card>
          </Row>
        </div>
      </>
    );
}

export default ApprovedSMSChannels;